import { FileTextOutlined } from '@ant-design/icons';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const templateGuide: FeatureGuide = {
    key: 'template',
    title: 'Templates',
    icon: <FileTextOutlined />,
    sections: [
        whatItIs(
            'A saved set of pre-filled fields that you can apply in one click - cutting setup time and reducing manual entry errors.'
        ),
        howItHelps(
            'Templates ensure consistency across declarations - the same details are applied correctly every time, without retyping.'
        ),
        tips([
            "Name templates clearly - so they're easy to identify later.",
            'Create separate templates for recurring or regular shipment types.',
            'Review template fields periodically - carrier details or regulations may change.',
        ]),
    ],
};
